export const capitalize = (str: string) => str[0].toUpperCase() + str.slice(1);

// Concatenate camel case strings into 1 camel case string
export function buildCamel(...args: string[]) {
  const [first, ...others] = args.filter(str => str.length);
  return [first, ...others.map(str => capitalize(str))].join('');
}
